import React from "react";
import { Box } from "@mui/material";
import GlassSearchBar from "../../../../ui/components/GlassSearchBar";

const DynamicSearchBar = ({
  searchTerm,
  setSearchTerm,
  placeholder = "Search...",
}) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", mb: 2, width: "100%" }}>
      <GlassSearchBar
        value={searchTerm}
        onChange={(nextValue) => setSearchTerm(nextValue.toLowerCase())}
        expandable={false}
        placeholder={placeholder}
        ariaLabel={placeholder}
        sx={{
          width: "100%",
          height: 40,
        }}
        inputSx={{ fontSize: 14 }}
      />
    </Box>
  );
};

export default DynamicSearchBar;